// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604071334/js/" + chunkId + "." + {"44":"b5f3723d","225":"80d6de99","481":"fbb52965","486":"fa4d67c5","770":"c9befb0c"}[chunkId] + ".0.876918651969792.chunk.js";
};